import { useQuery } from '@apollo/client';

import GetSystemProgramGql from '../queries/GetSystemProgram.graphql';
import type { GetSystemProgramQuery, GetSystemProgramQueryVariables } from '../queries/__generated__/GetSystemProgram';

export function useSystemProgram(organizationId: string | null | undefined) {
  const { data, loading } = useQuery<GetSystemProgramQuery, GetSystemProgramQueryVariables>(GetSystemProgramGql, {
    variables: { organizationId: organizationId ?? '' },
    skip: !organizationId,
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
  });

  return {
    systemProgram: data?.EnterpriseProgram?.getSystemProgram,
    loading,
  };
}
